/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RestartShutdownRequest = {
  agentId: string;
};

/** @internal */
export const RestartShutdownRequest$inboundSchema: z.ZodType<
  RestartShutdownRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type RestartShutdownRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const RestartShutdownRequest$outboundSchema: z.ZodType<
  RestartShutdownRequest$Outbound,
  z.ZodTypeDef,
  RestartShutdownRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function restartShutdownRequestToJSON(
  restartShutdownRequest: RestartShutdownRequest,
): string {
  return JSON.stringify(
    RestartShutdownRequest$outboundSchema.parse(restartShutdownRequest),
  );
}
export function restartShutdownRequestFromJSON(
  jsonString: string,
): SafeParseResult<RestartShutdownRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RestartShutdownRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RestartShutdownRequest' from JSON`,
  );
}
